import LoginCard from './components/LoginCard';
import RegisterCard from './components/RegisterCard';
export default {
  components: {
    LoginCard,
    RegisterCard
  },
  data() {
    return {
      isRegister: false
    };
  },
  created() {
    this.isRegister = this.$route.query.register === 'true';
  },
  methods: {
    handleToggle() {
      this.isRegister = !this.isRegister;
    }
  },
  watch: {
    $route() {
      this.isRegister = this.$route.query.register === 'true';
    }
  }
};